import { FaAward } from 'react-icons/fa';
import { FiUsers } from 'react-icons/fi';
import { VscFolderLibrary } from 'react-icons/vsc';

import Sitecore from '../../assets/sitecore.jpg';
import Azure from '../../assets/Azure.jpg';
import Ml from '../../assets/Ml.jpg';

export const AboutData = [
  {
    title: 'General',
    subtitle: 'Facts',
    icon: <VscFolderLibrary className="about__icon" />,
    description:
      'I am a Full Stack Software Engineer with experience in building secure, scalable, and cloud-native applications. I specialize in backend development, cloud deployments, CMS integrations, and modern frontend frameworks. My work improves platform security, system performance, and development efficiency across enterprise-scale systems.',
  },
  {
    title: 'Experience',
    subtitle: '5+ years',
    icon: <FiUsers className="about__icon" />,
    description:
      "I've worked as a software developer for more than 5 years in both product and client based companies. Proficient in object oriented design pattern to develop applications that are challenging to maintain. Worked on both front-end as well as back-end technologies. Scaled and Served multiple E-commerce websites. Optimized multiple product based API to serve in the developing markets.",
  },
  {
    title: 'Certifications',
    subtitle: 'Achieved',
    icon: <FaAward className="about__icon" />,
    description: (
      <div className="batches">
        <a
          href="https://drive.google.com/file/d/11kPFDu1ksfF5AgidyB5IzhG0Vb8amBvk/view"
          target="_blank"
          rel="noreferrer"
        >
          <div className="batch_icons">
            <img src={Sitecore} alt="Sitecore" />
          </div>
          <small>Sitecore Developer</small>
        </a>

        <a
          href="https://www.credly.com/badges/efda2d48-012b-46a7-a529-1a93dc4fa2f3?source=linked_in_profile"
          target="_blank"
          rel="noreferrer"
        >
          <div className="batch_icons">
            <img src={Azure} alt="Microsoft Azure" />
          </div>
          <small>Microsoft Azure</small>
        </a>

        <a
          href="https://www.coursera.org/account/accomplishments/verify/Z4K3DJ3G99DF"
          target="_blank"
          rel="noreferrer"
        >
          <div className="batch_icons">
            <img src={Ml} alt="Machine Learning" />
          </div>
          <small>Machine Learning Enthusiast</small>
        </a>
      </div>
    ),
  },
];